import {Link, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import './Header.css'

const Header = props => {
  const onLogout = () => {
    Cookies.remove('jwt_token')
    const {history} = props
    history.replace('/login')
  }

  return (
    <nav className="header">
      {/* Website Logo inside Link */}
      <Link to="/">
        <img
          src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
          alt="website logo"
          className="website-logo"
        />
      </Link>

      <ul className="nav-links">
        <li>
          <Link to="/" className="nav-link" data-testid="nav-home">
            Home
          </Link>
        </li>
        <li>
          <Link to="/jobs" className="nav-link" data-testid="nav-jobs">
            Jobs
          </Link>
        </li>
        <li>
          <button
            type="button"
            className="logout-button"
            onClick={onLogout}
            data-testid="logout"
            aria-label="Logout"
          >
            Logout
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default withRouter(Header)
